import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'
import Item from '../utilities/Data/Item'
import Colour from '../utilities/Data/Colour'
import maybe from '../utilities/maybe'

const setItemWant = async ({ want, item }) => {
	try {
		const { itemKey, colourName } = item
		const uid = getCurrentUid()
		const itemWanterDocRef = firestore.collection('items').doc(itemKey).collection('wanters').doc(uid)

		// want
		if (want) {
			const wanterDocSnap = await itemWanterDocRef.get()
			const isCreate = !wanterDocSnap.exists
			return await itemWanterDocRef.set({
				uid,
				itemKey,
				colourNames: { [Colour.canonicalName(colourName)]: true },
				...maybe({ createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, isCreate),
				modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
			}, { merge: true })
		}

		// un-want
		if (!colourName || Item.isSameColourName(colourName, Item.allColours)) {
			// all colours (delete from item page) - just remove the whole wanter doc
			return await itemWanterDocRef.delete()
		}

		// delete the specified colourName
		const operation = itemWanterDocRef.set({
			colourNames: { [Colour.canonicalName(colourName)]: firebase.firestore.FieldValue.delete() },
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
		}, { merge: true })

		// prepare cleanup that we do not want to wait for
		// delete wanter doc if no colourNames
		operation.then(async () => {
			const wanterDocSnap = await itemWanterDocRef.get()
			if (Object.keys(wanterDocSnap.data().colourNames).length === 0) {
				itemWanterDocRef.delete()
			}
		})

		return await operation
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default setItemWant



// WEBPACK FOOTER //
// ./src/dataservices/setItemWant.js